import { Pipe, PipeTransform } from "@angular/core";
import * as moment_ from 'moment';
const moment = moment_;
import * as _ from "lodash";

@Pipe({
  name: "timeFormat"
})
export class TimeFormatPipe implements PipeTransform {
  transform(time: any, format: any): any {
    if (_.isObject(time) && time instanceof moment) {
      return (time as any).format(format);
    } else if (_.isString(time)) {
      return moment(time).format(format);
    } else {
      return null;
    }
  }
}
